import { LinkButton } from '@coop/components';

const CheckoutOriginalSearchTermCta = ({
    queryUsed,
    originalQuery,
    onButtonClick,
}: {
    queryUsed: string;
    originalQuery: string;
    onButtonClick: () => void;
}) => {
    return (
        <>
            <span>Träffar för {queryUsed}, </span>
            <LinkButton
                size="small"
                onClick={onButtonClick}
                aria-label={`Sök istället efter ${originalQuery}, visar träffar för ${queryUsed}`}
            >
                <span className="u-textUnderline u-textWeightBold">
                    sök istället efter {originalQuery}
                </span>
            </LinkButton>
        </>
    );
};

export default CheckoutOriginalSearchTermCta;
